module.exports = __webpack_public_path__ + "img/program_img1.5856894e.png";